import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function InventoryStatistics() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
